import t from './theme';

var getButtonPadding = function getButtonPadding(props) {
  switch (props) {
    case props.hasIconOnly === true:
      return '0 4px';

    default:
      return '0 16px';
  }
};

var getButtonTextSize = function getButtonTextSize(props) {
  switch (props.size) {
    case 'small':
      return '12px';

    default:
      return '14px';
  }
};

var getLeftFontIconSize = function getLeftFontIconSize(props) {
  switch (props.leftIconSize) {
    case 'smallest':
      return '8px';

    case 'small':
      return '12px';

    case 'big':
      return '18px';

    case 'max':
      return '24px';

    default:
      return '16px';
  }
};

var getRightFontIconSize = function getRightFontIconSize(props) {
  switch (props.rightIconSize) {
    case 'smallest':
      return '8px';

    case 'small':
      return '12px';

    case 'big':
      return '18px';

    case 'max':
      return '24px';

    default:
      return '16px';
  }
};

var getButtonHeight = function getButtonHeight(props) {
  switch (props.size) {
    case 'small':
      return '24px';

    case 'big':
      return '44px';

    default:
      return '36px';
  }
};

var getButtonWidth = function getButtonWidth(props) {
  props.isFull ? '100%' : 'auto';
};

var getButtonTextColor = function getButtonTextColor(props) {
  switch (props.appearance) {
    case 'tertiary':
      return t.getPrimaryAppearance;

    case 'ghost':
      return t.getSecondaryAppearance;

    default:
      return t.getTertiaryAppearance;
  }
};

var getButtonAppearance = function getButtonAppearance(props) {
  switch (props.appearance) {
    case 'primary':
      return t.getPrimaryAppearance;

    case 'secondary':
      return t.getSecondaryAppearance;

    case 'tertiary':
      return t.getTertiaryAppearance;

    case 'destructive':
      return t.getDestructiveAppearance;

    case 'ghost':
      return t.getGhostAppearance;

    default:
      return t.getSecondaryAppearance;
  }
};

var getLoaderAppearance = function getLoaderAppearance(props) {
  switch (props.appearance) {
    case 'primary':
      return 'var(--white)';

    case 'secondary':
      return 'var(--white)';

    case 'tertiary':
      return t.getPrimaryAppearance;

    case 'destructive':
      return t.getDestructiveAppearance;

    case 'ghost':
      return t.getGhostAppearance;

    default:
      return t.getSecondaryAppearance;
  }
};

var getButtonBorderColor = function getButtonBorderColor(props) {
  switch (props.appearance) {
    case 'primary':
      return t.getPrimaryAppearance;

    case 'secondary':
      return t.getSecondaryAppearance;

    case 'tertiary':
      return t.getPrimaryAppearance;

    case 'destructive':
      return t.getDestructiveAppearance;

    case 'ghost':
      return t.getSecondaryAppearance;

    default:
      return t.getSecondaryAppearance;
  }
};

var getDismissButtonTextColor = function getDismissButtonTextColor(props) {
  switch (props.appearance) {
    case 'primary':
      return t.getPrimaryAppearance;

    case 'secondary':
      return t.getSecondaryAppearance;

    case 'tertiary':
      return t.getPrimaryAppearance;

    case 'destructive':
      return t.getDestructiveAppearance;

    default:
      return t.getSecondaryAppearance;
  }
};

var getButtonActiveShadow = function getButtonActiveShadow(props) {
  switch (props.appearance) {
    case 'primary':
      return 'inset 0 2px 4px 0 rgba(34, 34, 34, 0.5)';

    case 'secondary':
      return 'inset 0 2px 4px 0 rgba(34, 34, 34, 0.5)';

    case 'secondary':
      return 'none';

    default:
      return 'none';
  }
};

var getButtonActiveColor = function getButtonActiveColor(props) {
  switch (props.appearance) {
    case 'primary':
      return 'var(--disabled-orange)';

    case 'secondary':
      return 'var(--disabled-grey)';

    case 'tertiary':
      return 'var(--disabled-orange)';

    case 'destructive':
      return 'var(--white)';

    default:
      return 'none';
  }
};

var getDismissButtonAppearance = function getDismissButtonAppearance(props) {
  if (props.isDismiss) return t.getTransparentAppearance;
};

var getDisabledButtonTextColor = function getDisabledButtonTextColor(props) {
  if (props.isDisabled) return t.getDisabledTextAppearance;
};

var getDisabledButtonBackgroundColor = function getDisabledButtonBackgroundColor(props) {
  if (props.isDisabled) return t.getDisabledBackgroundAppearance;
};

export default {
  getButtonPadding: getButtonPadding,
  getButtonTextSize: getButtonTextSize,
  getLeftFontIconSize: getLeftFontIconSize,
  getRightFontIconSize: getRightFontIconSize,
  getButtonHeight: getButtonHeight,
  getButtonWidth: getButtonWidth,
  getButtonTextColor: getButtonTextColor,
  getButtonAppearance: getButtonAppearance,
  getButtonBorderColor: getButtonBorderColor,
  getDismissButtonTextColor: getDismissButtonTextColor,
  getDismissButtonAppearance: getDismissButtonAppearance,
  getDisabledButtonTextColor: getDisabledButtonTextColor,
  getDisabledButtonBackgroundColor: getDisabledButtonBackgroundColor,
  getButtonActiveColor: getButtonActiveColor,
  getButtonActiveShadow: getButtonActiveShadow,
  getLoaderAppearance: getLoaderAppearance
};